import { SimpleGrid, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StatBoxV2 } from '@feathr/components';
import { currencyFormatter } from '@feathr/extender/utils';

interface IGoalManagerStatsProps {
  activeCount: number;
  archivedCount: number;
}

function GoalManagerStats({
  activeCount,
  archivedCount,
}: Readonly<IGoalManagerStatsProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  // TODO: Replace with AggregatedStats once goal stats are done.
  // totalConversions: sum of num_conversions per goal from AggregatedStats.
  // totalConversionValue: sum of (goal.conv_value * num_conversions) per goal — frontend-computed.
  const totalConversions = 0;
  const totalConversionValue = 0;

  return (
    <SimpleGrid cols={{ base: 1, md: 2, lg: 4 }} spacing={theme.spacing['4']}>
      <StatBoxV2
        label={t('Active')}
        name={'active-goals'}
        primary={String(activeCount)}
        tooltip={t('Number of active goals')}
      />
      <StatBoxV2
        label={t('Total Conversions')}
        name={'total-conversions'}
        primary={totalConversions.toLocaleString('en-US')}
        tooltip={t('Total conversions tracked across all goals')}
      />
      <StatBoxV2
        label={t('Total Conversion Value')}
        name={'total-conversion-value'}
        primary={currencyFormatter.format(totalConversionValue)}
        tooltip={t('Total value of conversions tracked across all goals')}
      />
      <StatBoxV2
        label={t('Archived')}
        name={'archived-goals'}
        primary={String(archivedCount)}
        tooltip={t('Number of archived goals')}
      />
    </SimpleGrid>
  );
}

export default observer(GoalManagerStats);
